module.exports = __webpack_public_path__ + "expand_less-v1-cd7445fc.svg";